import { UPDATE_MY_BANKS, UPDATE_OFERTA_VIEW } from './types';


export function OfertaViewReducer(state, action) {

    const { payload, type } = action


    switch (type) {

        case UPDATE_MY_BANKS:
            return {
                ...state,
                myBanks: payload
            }

        case UPDATE_OFERTA_VIEW:
            return {
                ...state,
                ofertaViewData: payload
            }
        default:
            break;
    }

} 